/*
 * UI/UX改善 #3: セクション間ビジュアル遷移
 * SVGウェーブやアングルカットで視覚的なリズムを生む
 * 使い方: <SectionDivider variant="wave" fromColor="#FFFFFF" toColor="#F9F9F9" />
 */

interface SectionDividerProps {
  variant?: "wave" | "angle" | "curve";
  fromColor?: string;
  toColor?: string;
  flip?: boolean;
  className?: string;
}

export function SectionDivider({
  variant = "wave",
  fromColor = "#FFFFFF",
  toColor = "#F9F9F9",
  flip = false,
  className = "",
}: SectionDividerProps) {
  const transform = flip ? "scaleY(-1)" : undefined;

  if (variant === "wave") {
    return (
      <div className={`relative -mt-px ${className}`} style={{ background: toColor, transform }}>
        <svg
          viewBox="0 0 1440 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-8 lg:h-12 block"
          preserveAspectRatio="none"
        >
          <path
            d="M0 48V16C240 48 480 0 720 16C960 32 1200 0 1440 16V48H0Z"
            fill={fromColor}
          />
        </svg>
      </div>
    );
  }

  if (variant === "angle") {
    return (
      <div className={`relative -mt-px ${className}`} style={{ background: toColor, transform }}>
        <svg
          viewBox="0 0 1440 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-6 lg:h-10 block"
          preserveAspectRatio="none"
        >
          <polygon points="0,0 1440,40 0,40" fill={fromColor} />
        </svg>
      </div>
    );
  }

  // curve
  return (
    <div className={`relative -mt-px ${className}`} style={{ background: toColor, transform }}>
      <svg
        viewBox="0 0 1440 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-8 lg:h-12 block"
        preserveAspectRatio="none"
      >
        <path
          d="M0 48V24C360 0 1080 48 1440 24V48H0Z"
          fill={fromColor}
        />
      </svg>
    </div>
  );
}
